module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/RiceQ/Nagano_RiceQ_GFDL_RCP45_End.png";